<template>
  <div class="p-5 bg-gray-100 rounded flex flex-col justify-between">
    <div class="">
      <simple-input
        v-model="external_ref"
        name="external_ref"
        :label="i18n.external_ref.label"
        :labelInfo="i18n.external_ref.info"
      ></simple-input>

      <billing-data
        :data="billingData"
        v-if="billingData !== undefined"
      ></billing-data>

      <div
        v-if="billingData && billingData.amount_alert"
        class="border-orange-200 bg-orange-100 text-orange-800 -mx-5 p-5"
        v-html="billingData.amount_alert"
      ></div>
    </div>

    <div class="flex justify-center pt-5">
      <ranch-button
        :label="i18n.confirm"
        @click="confirm"
        :icon="['fas', 'credit-card']"
      ></ranch-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { handleAxiosError } from "@/boot/functions";

import SimpleInput from "../../Design/Forms/SimpleInput";
import BillingData from "../BillingData";

export default {
  props: ["credits", "countryId", "isCompany", "vatNumber"],
  components: { SimpleInput, BillingData },
  data() {
    return {
      external_ref: "",
      billingData: undefined,
    };
  },
  methods: {
    confirm() {
      this.$emit("confirm", this.external_ref);
    },
    getBillingDetails() {
      axios
        .post("/api/app/billing/refills/compute", {
          credits: this.credits,
          country_id: this.countryId,
          is_company: this.isCompany,
          vat: this.vatNumber,
        })
        .then(({ data }) => {
          this.billingData = data;
        })
        .catch(handleAxiosError);
    },
  },
  computed: {
    i18n() {
      if (this.$store.state.safe.i18n !== undefined) {
        return {
          ...this.$store.state.safe.i18n.new_refill.billing.confirmation,
          ...this.$store.state.safe.i18n.invoice.amounts,
        };
      }

      return undefined;
    },
  },
  mounted() {
    this.getBillingDetails();
  },
};
</script>
